import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router'
import { BuildingIcon, PlugIcon, UserIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

export const Route = createFileRoute('/_app/$org/settings')({
  component: SettingsLayout,
})

const SECTIONS = [
  { to: '/$org/settings/workspace', key: 'workspace', label: 'Workspace', icon: BuildingIcon },
  { to: '/$org/settings/connections', key: 'connections', label: 'Connections', icon: PlugIcon },
  { to: '/$org/settings/account', key: 'account', label: 'Account', icon: UserIcon },
] as const

function SettingsLayout() {
  const { org } = Route.useParams()
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const current = pathname.split('/').at(-1)

  return (
    <div className="flex flex-col gap-8 sm:flex-row">
      <nav className="flex shrink-0 gap-1 sm:w-44 sm:flex-col">
        {SECTIONS.map((section) => {
          const active = current === section.key
          return (
            <Link
              key={section.key}
              to={section.to}
              params={{ org }}
              className={cn(
                'flex items-center gap-2 rounded-md px-2.5 py-1.5 text-[13px] transition-colors',
                active
                  ? 'bg-plum-selected text-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-foreground',
              )}
            >
              <section.icon className={cn('size-3.5', active ? 'text-plum' : 'opacity-70')} />
              {section.label}
            </Link>
          )
        })}
      </nav>

      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  )
}
